import { create } from "zustand";
import { MasterListItem } from "pages/seniorMaster/finance/types";

export type MasterInvoiceStoreState = {
  list: { isLoaded: boolean; data: MasterListItem[] };
  setList: (list: { isLoaded: boolean; data: MasterListItem[] }) => void;
  isPostInProcess: boolean;
  setIsPostInProcess: (isPostInProcess: boolean) => void;
  isSubmittable: boolean;
  setIsSubmittable: (isSubmittable: boolean) => void;
  isError: boolean;
  setIsError: (isError: boolean) => void;
  isFileUploading: boolean;
  setIsFileUploading: (isFileUploading: boolean) => void;
  isChangeStatusInProcess: { [objectId: number]: boolean };
  setIsChangeStatusInProcess: (
    updater:
      | { [objectId: number]: boolean }
      | ((prevState: {
          [objectId: number]: boolean;
        }) => { [objectId: number]: boolean })
  ) => void;
  isConfirmInProcess: { [objectId: number]: boolean };
  setIsConfirmInProcess: (
    updater:
      | { [objectId: number]: boolean }
      | ((prevState: {
          [objectId: number]: boolean;
        }) => { [objectId: number]: boolean })
  ) => void;
  isTableHidden: boolean;
  setIsTableHidden: (
    updater: boolean | ((prevState: boolean) => boolean)
  ) => void;
};

const useMasterInvoiceStore = create<MasterInvoiceStoreState>((set) => ({
  list: {
    isLoaded: false,
    data: [],
  },
  setList: (list) => set({ list }),
  isPostInProcess: false,
  setIsPostInProcess: (isPostInProcess) => set({ isPostInProcess }),
  isSubmittable: false,
  setIsSubmittable: (isSubmittable) => set({ isSubmittable }),
  isError: false,
  setIsError: (isError) => set({ isError }),
  isFileUploading: false,
  setIsFileUploading: (isFileUploading) => set({ isFileUploading }),
  isChangeStatusInProcess: {},
  setIsChangeStatusInProcess: (updater) => {
    if (typeof updater === "function") {
      set((state) => ({
        isChangeStatusInProcess: updater(state.isChangeStatusInProcess),
      }));
    } else {
      set({ isChangeStatusInProcess: updater });
    }
  },
  isConfirmInProcess: {},
  setIsConfirmInProcess: (updater) => {
    if (typeof updater === "function") {
      set((state) => ({
        isConfirmInProcess: updater(state.isConfirmInProcess),
      }));
    } else {
      set({ isConfirmInProcess: updater });
    }
  },
  isTableHidden: true,
  setIsTableHidden: (updater) =>
    set((state) => ({
      isTableHidden:
        typeof updater === "function" ? updater(state.isTableHidden) : updater,
    })),
}));

export default useMasterInvoiceStore;
